import { render, staticRenderFns } from "./LdFullscreenExpansion.vue?vue&type=template&id=1acdd152&"
import script from "./LdFullscreenExpansion.vue?vue&type=script&lang=js&"
export * from "./LdFullscreenExpansion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports